<template>
	<div class="transparent-video-container">
		<video ref="source" class="video-source" playsinline autoplay muted v-on="$listeners">
			<source :src="src" type='video/mp4; codecs="avc1.42E01E"' />
		</video>
		<canvas :width="size.width" :height="size.height" ref="buffer" class="buffer" />
		<canvas :width="size.width" :height="size.height / 2" ref="output"
			:class="['output', { cover }]" />
	</div>
</template>

<script>
import { allObjectValuesAreNumbers } from '@/lib/validators';

export default {
	name: 'VideoTransparency',
	props: {
		src: {
			type: String,
			required: true,
		},
		size: {
			type: Object,
			required: true,
			validator: allObjectValuesAreNumbers,
		},
		cover: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		width() {
			return this.size.width;
		},
		height() {
			return this.size.height / 2;
		},
	},
	watch: {
		async src(newSrc, oldSrc) {
			if (newSrc !== oldSrc) {
				await this.$refs.source.load();
				await this.$refs.source.play();
			}
		},
	},
	methods: {
		initialize() {
			this.$refs.source.addEventListener('play', () => {
				clearInterval(this.interval);
				this.interval = setInterval(this.processFrame, 40);
			}, false);

			this.$refs.source.addEventListener('pause', () => {
				clearInterval(this.interval);
			}, false);
		},
		processFrame() {
			this.canvas.buffer.drawImage(this.$refs.source, 0, 0);

			const frame = this.canvas.buffer.getImageData(0, 0, this.width, this.height);
			const frameData = frame.data;
			const alphaData = this.canvas.buffer.getImageData(0, this.height, this.width, this.height).data;

			for (let frameIndex = 3; frameIndex < frameData.length; frameIndex += 4) {
				frameData[frameIndex] = alphaData[frameIndex - 1];
			}

			this.canvas.output.putImageData(frame, 0, 0, 0, 0, this.width, this.height);
		},
	},
	// declare non-reactive properties
	created() {
		this.canvas = { output: null, buffer: null };
		this.interval = null;
	},
	mounted() {
		this.canvas.output = this.$refs.output.getContext('2d');
		this.canvas.buffer = this.$refs.buffer.getContext('2d');
		this.initialize();
		this.$refs.source.play();
	},
	beforeDestroy() {
		this.$refs.source.pause();
		clearInterval(this.interval);
	},
};
</script>

<style lang="scss" scoped>
	.video-source {
		display: none;
	}

	canvas {
		pointer-events: none;
	}

	.buffer {
		display: none;
	}

	.output {
		width: 100%;

		&.cover {
			height: 100%;
			object-fit: cover;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/VideoTransparency.vue